if (!customElements.get('product-recommendations')) {
	customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
  
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = this.classList.contains('related-products') ? html.querySelector('.related-products') : html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.recommendation-list')) {
              console.log('if');
              this.classList.add('product-recommendations--loaded');
              /** End Swym integration **/
              document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
              
            } else {
              console.log('else');
              this.classList.add('hidden');
            }
          })
          .catch(e => {
            console.error(e);
            this.classList.add('hidden');
          })
          .finally(() => {
            var recom_imgWrappers = document.querySelectorAll('.product-card-img-wrapper');
            let recom_productCardHeight = `${document.querySelector('.custom__product-card .product-card-img-wrapper > img.main_product_img').offsetHeight}px`;

            const recom_addHeight = (e) => {
                // console.log(productCardHeight);
                let recom_productCardHeight = `${document.querySelector('.custom__product-card .product-card-img-wrapper > img.main_product_img').offsetHeight}px`
                e.target.querySelector('.carousel').style.height = recom_productCardHeight
                e.target.querySelector('.flickity-viewport').style.height = recom_productCardHeight
                e.target.querySelectorAll('.carousel .carousel-cell').forEach(cell => {
                  cell.style.height = recom_productCardHeight
                  cell.querySelector('img').style.height = recom_productCardHeight
                })
              }
            
            const recom_removeHeight = (e) => {
              e.target.querySelector('.carousel').style.height = "0"
              e.target.querySelector('.flickity-viewport').style.height = "0"
              e.target.querySelectorAll('.carousel .carousel-cell').forEach(cell => {
                cell.style.height = "0"
                cell.querySelector('img').style.height = recom_productCardHeight
              })
            }
        
            const recom_addSelectedClass = (e) => {
              e.target.closest('li.grid__item').classList.add('selected')
            }
            
            const recom_removeSelectedClass = (e) => {
              e.target.closest('li.grid__item').classList.remove('selected')
            }

            if (window.innerWidth > 749) {
              recom_imgWrappers.forEach(item => {
                item.addEventListener('mouseenter', (e) => {
                  recom_addHeight(e)
                  recom_addSelectedClass(e)
                })
                item.addEventListener('mouseleave', (e) => {
                  recom_removeHeight(e)
                  recom_removeSelectedClass(e)
                })
              })
            }

            //console.log('call1',document.querySelector('.similar_modal_btn'));
            // document.querySelector('.similar_modal_btn').addEventListener('click',function(e){
            //   console.log('clcik');
            //   e.target.closest('.container-one').querySelector('.silimar_product_variant_drawer details-modal summary').click();
            // })
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
    }
  });
}